import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { adminChangePartnerApprovalStatus, updateSalesAgentRatesApi, salesAgentByIdApi, approveOrRejectSalesAgentDocumentsApi, uploadFileApi, adminGetDriverDetailsById, updatePartnerProfileApi, adminGetAllUserList, savePartnerBankDetailsApi, updateDriverDocsApi, updateSalesAgentDocsApi, getAllRaferralsApi, getSalesAgentRatesApi, addSalesAgentRatesApi, updateSalesAgentRateApi } from '../../../utils/ApiEndpointFunctions';
import Spinwheel from '../../common/Spinwheel';
import { capitalizeWords, dateFormat } from '../../../utils/HelperFuncitons';
import { S3_URL } from '../../../utils/BaseUrl';
import ConfirmationModal from '../../common/ConfirmationModal';
import toast from 'react-hot-toast';
import CommonTable from '../../common/Table/CommonTable';
import { useFormik } from 'formik';
import { bankDetailsInitialValue, bankDetailsValidationSchema, profileDetailsInitialValue, profileValidationSchema, salesAgentInitialValues, salesAgentRateInitialValues, salesAgentRatesValidationSchema, salesAgentValidationSchema } from '../../common/Validation';
import PdfSvgIcon from '../../common/PdfSvgIcon';
import ImageViewModal from '../../common/Modal/ImageViewModal';
import DatePicker from "react-datepicker";
import AddOrUpdateDetails from '../../common/Modal/AddOrUpdateDetails';
import ReactPaginate from 'react-paginate';
import { Button, Dropdown, Modal, Table } from 'react-bootstrap';



const SalesAgentDetails = () => {
    const params = useParams();
    const [id] = useState(params?.id)
    const [allDrivers, setAllDrivers] = useState([])
    const [profileDetails, setProfiledetails] = useState({});
    const [salesAgentDetails, setSalesAgentDetails] = useState({});
    const [driverDetails, setDriverDetails] = useState({});
    const [vehicleDetails, setVehicleDetails] = useState([]);
    const [bankDetails, setBankDetails] = useState([]);
    const [bonusDetails, setBonusDetails] = useState([]);
    const [rateLoader, setRateLoader] = useState(false);
    const [pagination, setPagination] = useState({
        totalPages: 0,
        currentPage: 1
    });
    const [pageInfo, setPageInfo] = useState({
        totalPagesCount: 0,
        currentPageNumber: 1,
        itemsPerPage: 10,
    });
    const [pageLoading, setPageLoading] = useState(false);
    const [selectedPage, setSelectedPage] = useState(1);
    const [loader, setLoader] = useState(true);
    const [activeTab, setActiveTab] = useState('driver');
    const [confirmStatus, setConfirmStatus] = useState({ status: "", userId: "", role: "salesAgent" });
    const [selectDocument, setSelectDocument] = useState({ status: "", keyName: "", validDate: "", restaurantId: "" });
    const [selectedImg, setSelectedImg] = useState("")
    const confirmationModalId2 = "confirmationModal2"
    const driverBankModal2 = "driverBankModal2"
    const [detailsType,setDetailsType] = useState({type:"",loading:false})
    const [fileUpload,setFileUpload] = useState([])
    const [selectedDocument,setSelectedDocument] = useState({id:null,type:null,loading:false})
    const [salesAgentDocuments,setSalesAgentDcuments] = useState({})
    const [walletHistories, setWalletHistories] = useState([]); // 👈 new state
    const [walletLoading, setWalletLoading] = useState(false); // loader for wallet table
    const [refferals,setRefferals]= useState([]);
      const [showModal, setShowModal] = useState(false);
        const [selectedItem, setSelectedItem] = useState(null);
    const [rateData ,setRateData] = useState([])
    const [showTypeField,setShowTypeField] = useState(true)



// const data = [
//     { id: 1, type: "Driver", commission: 30, reward: "Yes" },
//     { id: 2, type: "Rider", commission: 40, reward: "No" },
//     { id: 3, type: "Partner", commission: 20, reward: "Yes" },
//     { id: 4, type: "FleetOwner", commission: 50, reward: "No" },
//     { id: 5, type: "BusOperator", commission: 10, reward: "Yes" },
//   ];





//         useEffect(()=>{
//  console.log("driver details agent",profileDetails)
//         },[profileDetails])

// console.log("dfgdfgdgdgd")

        const fetchSalesAgentDetails = async (id) => {
            try {
                setLoader(true);
                const res = await salesAgentByIdApi({ id });
                if (res.status === 200) {
                    const { id, role, phone, salesAgent, bankDetails, partnerUserDetails } = res.data.data.details;
                    setProfiledetails({
                        id,
                        phone,
                        role,
                        ...partnerUserDetails[0],
                        approvalStatus: salesAgent?.status
                    });
                    setSalesAgentDetails(salesAgent);
                    setBankDetails(bankDetails);
                    // rateFormik.setValues({
                    //     id: id,
                    //     rewardPercentage: salesAgent.rewardPercentage,
                    //     from: salesAgent.createdAt,
                    //     to: salesAgent.rewardExpiryDate,
                    //     rewardOnOff: salesAgent.rewardOnOff
                    // });
                }
            } catch (error) {
                console.error(error);
            } finally {
                setLoader(false);
            }
        };

        // Fetch wallet histories only
        const fetchWalletHistories = async (id, page = 1, limit = 10) => {
            try {
                setWalletLoading(true);
                const res = await salesAgentByIdApi({ id, page, limit });
                if (res.status === 200) {
                    setWalletHistories(res.data.data.walletHistories || []);
                    setPagination(res.data.data.pagination || { totalPages: 0, currentPage: 1 });
                }
            } catch (error) {
                console.error(error);
            } finally {
                setWalletLoading(false);
            }
        };
        useEffect(() => {
            if (id) {
                fetchSalesAgentDetails(id);
            }
        }, [id]);

        // Wallet histories effect
        useEffect(() => {
            if (id) {
                fetchWalletHistories(id, selectedPage, 10);
            }
        }, [id, selectedPage]);
    // Page Change Handler
    const handlePageClick = (event) => {
        const page = event.selected + 1; // react-paginate 0-based hota hai
        setSelectedPage(page);
    };
    
    useEffect(()=>{
       console.log("walletHistories", walletHistories);
    },[walletHistories])

    const genderOptions = [
        {label:"Male",value:"male"},
        {label:"Female",value:"female"},
        {label:"Other",value:"other"},
    ]

    //   const driverDetailsFormik = useFormik({
    //         initialValues:detailsFields?.[activeTab]?.initialvalue,
    //         validationSchema:detailsFields?.[activeTab]?.validationSchema,
    //         enableReinitialize:true,
    //         onSubmit:detailsFields?.[activeTab]?.handleSubmit
    //     })

    const getSalesAgentRates = async ()=>{
        try {
            const res = await getSalesAgentRatesApi(id)
            if(res.status===200){
                console.log("check",res?.data?.data[0]?.commission)
                setRateData(res?.data?.data[0]?.commission)
            }
        } catch (error) {
             console.log(error.message);
        }
    }

    useEffect(()=>{
       if(id){
        getSalesAgentRates()
       }
    },[activeTab==="rate"])


    const getAllRaferrals = async (id, pageNumber = 1, itemsPerPage = 10) => {
        try {
              setPageLoading(true);
            const res = await getAllRaferralsApi(id, pageNumber, itemsPerPage);
            if (res.status === 200 || res.status === 1) {
                setRefferals(res?.data?.data || []);

                const totalItems = res?.data?.count || 0;
                setPageInfo({
                    totalPagesCount: Math.ceil(totalItems / itemsPerPage),
                    currentPageNumber: pageNumber,
                    itemsPerPage: itemsPerPage,
                });
                setPageLoading(false)
            }
        } catch (error) {
            console.log(error.message);
        }
    };

    useEffect(() => {
        if (profileDetails?.id) {
            getAllRaferrals(profileDetails.id, 1, pageInfo.itemsPerPage);
        }
    }, [profileDetails]);

    useEffect(()=>{
     console.log("data",refferals)
    },[refferals])

    const handleChangeStatus = async () => {
        try {
            setLoader(true)
            await adminChangePartnerApprovalStatus(confirmStatus)
            await fetchSalesAgentDetails();
            document.getElementById('confirmationModal').click()
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something Went Wrong")
            setLoader(false)
        }
    }

    const onPageChangeHandler = (event) => {
        const selectedPageNumber = event.selected + 1; // react-paginate 0-based hota hai
        getAllRaferrals(profileDetails.id, selectedPageNumber, pageInfo.itemsPerPage);
    };

    const toggleTab = (tab) => {
        setActiveTab(tab);
    };

    async function handleFileUpload (name,e,formik){
        try {
          const file = e.target.files[0];
          if (file) {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("type", "documents")
            setFileUpload([...fileUpload,name])
            const res = await uploadFileApi(formData)
            formik.setFieldTouched(name, true)
            if (res.status === 200 && res.data?.status === 1) {
              formik.setFieldValue(name, res.data?.data);
              toast.success("File uploaded");
            }
          }
        } catch (error) {
          formik.setFieldTouched(`image`, true)
          console.log(error)
          if (error?.response === undefined) {
            toast.error("File size is too large")
          }
        }
        setFileUpload([...fileUpload?.filter(ele=>ele!=name)])
      }

      const fetchDriverDetails = async () => {
              try {
                  const res = await adminGetDriverDetailsById(id);
                  if (res.status === 200) {
                    console.log("driver fetch",res.data)
                      const { id, role, phone, driverDetails, partnerUserDetails, vehicles, bankDetails, driverBonus } = res.data.data;
                      setDriverDetails({ id, phone, role, ...driverDetails[0], ...partnerUserDetails[0] });
                      setVehicleDetails(vehicles);
                      setBankDetails(bankDetails)
                      setBonusDetails(driverBonus)
                  }
                  setLoader(false);
              } catch (error) {
                  setLoader(false);
                  console.log(error);
              }
          };

    const bankDetailsHeaderData = [
        { name: "Account Holder Namer", className: "list-sort text-muted", key: "name" },
        { name: "Bank Name", className: "list-sort text-muted", key: "bankName" },
        { name: "IFSC", className: "list-sort text-muted", key: "Ifsc" },
        { name: "Account Number", className: "list-sort text-muted", key: "accountNo" },
        { name: "Account Type", className: "list-sort text-muted", key: "accountType" },
        { name: <div className='d-flex gap-2 justify-content-center align-items-center'><div>Action</div><div>{!bankDetails?.length && <button className='btn btn-primary' data-bs-toggle="modal" data-bs-target={`#driverBankModal2`}>Add</button>}</div></div>, className: "col-1", key: "action" },
    ]

    const bankDetailsTableData = bankDetails?.map((bnk, index) => ({
        name: profileDetails.name || "",
        bankName: bnk.bankName || "",
        Ifsc: bnk.Ifsc || "",
        accountNo: bnk.accountNo || "",
        accountType: bnk.accountType || "",
        action: (
            // <span
            //   style={{ cursor: "pointer" }}
            //   data-bs-toggle="modal"
            //   data-bs-target={`#driverBankModal2`}
            //   onClick={() => {
            //     salesAgentDetailsFormik?.setValues({
            //       ...bnk,
            //       name: {
            //         label: salesAgentDetails?.name,
            //         value: salesAgentDetails?.name,
            //       },
            //     });
            //     setActiveTab("bankDetails");
            //   }}
            // >
            //   Edit
            // </span>
            <div className="dropdown">
            <button
              className=" border-0 bg-white"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-three-dots-vertical"
                viewBox="0 0 16 16">
                <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
              </svg>
            </button>
            <ul
              className="dropdown-menu"
              style={{ zIndex: "1000" }}>
              <li
                data-bs-toggle="modal"
                  data-bs-target={`#driverBankModal2`}
                  onClick={() => {
                    salesAgentDetailsFormik?.setValues({
                      ...bnk,
                      name: {
                        label: salesAgentDetails?.name,
                        value: salesAgentDetails?.name,
                      },
                    });
                    setActiveTab("bankDetails");
                  }}
               >
                <a className="dropdown-item" href="#">
                  Edit
                </a>
              </li>
            </ul>
          </div>
          ),
    }))

    const profileData = [
        { name: "Email", data: profileDetails.email, },
        { name: "Phone", data: profileDetails.phone, },
        { name: "Alternate Phone", data: profileDetails.alternateMobile, },
        { name: "NIN", data: profileDetails.NIN, },
        { name: "Status", data: capitalizeWords(profileDetails.approvalStatus), },
        { name: "Role", data: profileDetails.role?.map(el => capitalizeWords(el))?.join(", "), },
        { name: "Gender", data: profileDetails.gender, },
        { name: "City", data: profileDetails.city, },
        { name: "State", data: profileDetails.state, },
        { name: "Country", data: profileDetails.country, },
        { name: "Zip Code", data: profileDetails.zip, },
        { name: "Address", data: <div>{profileDetails.permanentAddress && `${profileDetails.permanentAddress}, `}{profileDetails.state && `${profileDetails.state}, `}{profileDetails.city && `${profileDetails.city}, `}{profileDetails.zip && `${profileDetails.zip}`}</div>, },

    ]

    function handleInputChange(name,e,formik,input,type){
        if(input=="input"){
            const {value} = e?.target
            if(type=="number" && isNaN(value)) return
            formik.setFieldValue(name,value)
        }else if(input=="date"){
            formik.setFieldValue(name,e)
        }else if(input=="select"){
            let list = [{name,value:e}]
            if(name=="categoryId"){
                list.push({name:"modelId",value:""},{name:"makeId",value:""})
            }else if(name=="modelId"){
                list.push({name:"makeId",value:""})
            }

            list?.forEach(ele=>{
                formik.setFieldValue(ele?.name,ele?.value)
            })
        }else if(input=="address"){
            formik.setFieldValue(name,e?.label)
        } else if (input == "toggle") {
            formik.setFieldValue(name, e); // e is true/false
  }
        
    }

    // const rateSubmit = async (values) => {
    //     setRateLoader(true)
    //     try {
    //         const res = await updateSalesAgentRatesApi(values)
    //         if (res.status === 200) {
    //             toast.success(res.data.message)
    //         }
    //     } catch (error) {
    //         toast.error("Failed to update rate")
    //     }
    //     setRateLoader(false)
    //     console.log(values)
    // }

    // const rateFormik = useFormik({
    //     initialValues: salesAgentInitialValues,
    //     validationSchema: salesAgentRatesValidationSchema,
    //     onSubmit: rateSubmit
    // })

    const openModal = () => {
        document.getElementById('confirmationModal2Btn').click()
    }

    async function handleDriverDetailSubmit(payload, apiEndPoint) {
        try {
            console.log("in try block")
            setDetailsType({ ...detailsType, loading: true })
            const res = await apiEndPoint({ ...payload, partnerUserId: id })
            if (res?.status == 200 || res?.status == 201) {
                fetchDriverDetails();
                if(activeTab==="document"){
                   await fetchSalesAgentDetails()
                }
                if(activeTab==="rate"){
                   await getSalesAgentRates()
                }
                document.getElementById(detailsFields[activeTab]?.modalId)?.click()
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something Went Wrong")
        }
        setDetailsType({ ...detailsType, loading: false })
    }

    //   const getAllDrivers = async () => {
    //         try {
    //             const res = await adminGetAllUserList("", "", "", "driver");
    //             if (res.status === 200) {
    //                 setAllDrivers(res.data?.data?.findPartners)
    //             }
    //         } catch (error) {
    
    //         }
    //     }

    //     useEffect(()=>{
    //         fetchDriverDetails()
    //         getAllDrivers()
    //     },[])

     useEffect(() => {
            if (id) {
                fetchDriverDetails();
            }
        }, [id]);

    const commissionOptions=[
        {label:"Fleet owner",value:"fleetOwner"},
        {label:"Driver",value:"driver"},
        {label:"Bus Operator",value:"busOperator"},
        {label:"Car rental",value:"carRental"},
        {label:"Restaurant",value:"restaurant"},
    ]

    const formatDate = (date) => {
  if (!date) return null;
  return (date instanceof Date) ? date.toISOString().split("T")[0] : date;
}

    const detailsFields = {
         "bankDetails": {
                       format: [
                           { name: "bankName", label: "Bank Name", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                           { name: "accountNo", label: "Account No", type: "input", handleOnChange: (...values) => handleInputChange(...values, "number") },
                           { name: "accountType", label: "Account Type", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                           { name: "Ifsc", label: "IFSC", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                           
                       ],
                       initialvalue: bankDetailsInitialValue,
                       validationSchema: bankDetailsValidationSchema,
                       handleSubmit: (values) => handleDriverDetailSubmit(values, savePartnerBankDetailsApi),
                       modalId: driverBankModal2
                   },
           
            "driver": {
                format: [
                    { name: "profileImage", label: "Profile image", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("profileImage"), handleFileUpload },
                    { name: "name", label: "Name", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                    { name: "alternateMobile", label: "Alternate mobile", type: "input", handleOnChange: (...values) => handleInputChange(...values, "number") },
                    { name: "email", label: "Email", type: "input", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                    { name: "NIN", label: "NIN", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                    { name: "permanentAddress", label: "Permanent address", type: "address", handleOnChange: (...values) => handleInputChange(...values, "text") },
                    { name: "gender", label: "Gender", type: "select", options: genderOptions, handleOnChange: (...values) => handleInputChange(...values, "text") },
                ],
                initialvalue: profileDetailsInitialValue,
                           validationSchema: profileValidationSchema,
                           handleSubmit: (values) => handleDriverDetailSubmit({ ...values, gender: values?.gender?.value }, updatePartnerProfileApi),
                           modalId: driverBankModal2
            },
            "rate":{
                 format: [
                    showTypeField && { name: "type", label: "Type", type: "select", options: commissionOptions, handleOnChange: (...values) => handleInputChange(...values, "text") },
                    { name: "commission", label: "Commission", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                    { name: "from", label: "From",  type: "date", handleOnChange: (...values) => handleInputChange(...values, "date") },
                    { name: "to", label: "To", type: "date", handleOnChange: (...values) => handleInputChange(...values, "date") },
                    { name: "reward", label: "Reward", type: "toggle", handleOnChange: (...values) => handleInputChange(...values, "toggle") },
                    // { name: "gender", label: "Gender", type: "select", options: genderOptions, handleOnChange: (...values) => handleInputChange(...values, "text") },
                ],
                initialvalue: salesAgentRateInitialValues,
                           validationSchema: salesAgentValidationSchema,
                        //    handleSubmit: (values) => console.log("valvalval",[{...values,to:values.to.toISOString().split("T")[0],from:values.from.toISOString().split("T")[0]}]),
                         handleSubmit: (values) => {
                            !(values?.id)? (
                                handleDriverDetailSubmit({ "commissionData": [{ ...values, to: values.to.toISOString().split("T")[0], from: values.from.toISOString().split("T")[0] }] }, addSalesAgentRatesApi)
                            ) : (
                                handleDriverDetailSubmit({
                                    ...values,
                                    to: formatDate(values.to),
                                    from: formatDate(values.from)
                                }, updateSalesAgentRateApi)
                            )
                         },
                           modalId: driverBankModal2
            },
             "document": {
                        format: [
                            ...(selectedDocument.type == "Driving Licence" ?
                                [
                                    { name: "drivingLicence", label: "Driving Licence", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("drivingLicence"), handleFileUpload },
                                    { name: "drivingLicenceValidUpto", label: "Valid upto", type: "date", handleOnChange: (...values) => handleInputChange(...values, "text") },
                                ] :
                                (selectedDocument.type == "National Id" ?
                                    [
                                        { name: "nationalId", label: "National Id", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("nationalId"), handleFileUpload },
                                        // { name: "nationalId", label: "Valid upto", type: "date", handleOnChange: (...values) => handleInputChange(...values, "text") },
                                    ]  : [])
            
                            ),
                        ],
                        initialvalue: profileDetailsInitialValue,
                                   // validationSchema:{},
                                   handleSubmit: (values) => {
                                       let preferredKeys = detailsFields[activeTab]?.format?.map(ele => ele?.name)
                                       let payload = {}
                                       preferredKeys?.map(ele => {
                                           payload[ele] = values[ele]
                                       })
                                    //    console.log("preferredKeys", preferredKeys, payload);
                       
                                       handleDriverDetailSubmit({ ...payload }, updateSalesAgentDocsApi)
                                   },
                                   modalId: driverBankModal2
                    }
            
        }


      const salesAgentDetailsFormik = useFormik({
            initialValues:detailsFields?.[activeTab]?.initialvalue,
            validationSchema:detailsFields?.[activeTab]?.validationSchema,
            enableReinitialize: true,
            onSubmit:detailsFields?.[activeTab]?.handleSubmit
        })

      
console.log(salesAgentDetailsFormik?.values, "valuess")

    const handleChangeDocumentStatus = async () => {
        const promise = approveOrRejectSalesAgentDocumentsApi({ userId: id, keyName: selectDocument.keyName, validDate: selectDocument.validDate, status: selectDocument.status, restaurantId: selectDocument.restaurantId });
        toast.promise(
            promise,
            {
                loading: 'Updating document status...',
                success: (res) => {
                    if (res.status === 200) {
                        profileDetails.approvalStatus = res.data.salesAgentStatus
                        setSalesAgentDetails({ ...salesAgentDetails, [selectDocument.keyName]: res.data.docStatus })
                        return res.data.message || 'Success';
                    }
                },
                error: (err) => {
                    return err.message || 'Something Went Wrong'
                }
            }
        )
    };

    const DocumentDisplay = ({ title, document, setSelectedImg, status, keyName, validUpto, number, restaurantId }) => {

        console.log({ title, document, setSelectedImg, status, keyName, validUpto, number, restaurantId })

        if (!document) {
            return (
                <tr>
                    <td>{title}</td>
                    <td className='text-center'>{`${title} not available`}</td>
                </tr>
            );
        }

        const isPdf = document ? document.split(".").slice(-1)[0] === "pdf" : "";

        return (
            <tr>
                <td>{title}</td>
                <td className='text-center'>
                    {isPdf ? (
                        <Link to={`${S3_URL}/${document}`} className="text-primary">
                            <PdfSvgIcon width="100" height="100" />
                        </Link>
                    ) : (
                        <img
                            src={`${S3_URL}/${document}`}
                            alt={title}
                            data-bs-toggle="modal"
                            data-bs-target={`#imageViewModal`}
                            style={{ cursor: 'pointer', maxWidth: '100%', maxHeight: '100px', borderRadius: "8%" }}
                            onClick={() => setSelectedImg(`${S3_URL}/${document}`)}
                        />
                    )}
                </td>
                <td className='text-center'>{validUpto ? dateFormat(validUpto) : ""}</td>
                <td className='text-center'>{capitalizeWords(status) || "-"}</td>
                {status !== "pending" && <td className='text-center'>
                    <div className="dropdown">
                        <button
                            className=" border-0 bg-white"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-three-dots-vertical"
                                viewBox="0 0 16 16"
                            >
                                <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                            </svg>
                        </button>
                        <ul
                            className="dropdown-menu"
                            style={{ zIndex: "1000" }}
                        >
                            {(status === "rejected" || status === "submitted") && <li
                                onClick={() => {
                                    console.log(validUpto, "validUpto")
                                    setSelectDocument({ status: 'approved', keyName: keyName, validDate: validUpto, restaurantId: restaurantId })
                                    openModal()
                                }}
                            >
                                <a className="dropdown-item" href="#">
                                    Approve
                                </a>
                            </li>}

                            {(status === "approved" || status === "submitted") && <li
                                onClick={() => {
                                    setSelectDocument({ status: 'rejected', keyName: keyName, validDate: validUpto, restaurantId: restaurantId })
                                    openModal()
                                }}
                            >
                                <a className="dropdown-item" href="#">
                                    Reject
                                </a>
                            </li>}

                            <li data-bs-toggle="modal" data-bs-target={`#${driverBankModal2}`} onClick={() => { 
                setSelectedDocument({...selectedDocument,type:title});
                            salesAgentDetailsFormik?.setValues({
                              ...salesAgentDetails,
                              name: {
                                label: salesAgentDocuments?.name,
                                value: salesAgentDocuments?.name,
                              },
                                });
                                setActiveTab("document") }}>
                            <a className="dropdown-item" href="#">
                                Edit
                            </a>
                        </li>
                        </ul>
                    </div>
                </td>}
            </tr>
        );
    };


    const handleRewardToggle = async (row, newReward) => {
        try {

            setRateData((prev) =>
                prev.map((r) =>
                    r.type === row.type ? { ...r, reward: newReward } : r
                )
            );

            const payload = { ...row, reward: newReward, partnerUserId: id }

            console.log("rowwww", row, newReward)
            console.log("new Reward", newReward)

            // API call
            const res =  await updateSalesAgentRateApi(payload);
            
            if(res.status===200){
                toast.success(res?.data?.message)
            }

            console.log("Reward updated successfully");
        } catch (error) {
            console.error("Failed to update reward:", error);
            setRateData((prev) =>
                prev.map((r) =>
                    r.type === row.type ? { ...r, reward: !newReward } : r
                )
            );
             toast.error(
            error.response?.data?.message ||
            error.message ||
            "Something went wrong!"
        );
        }
    };


    const tabData = [
        {
            name: "Profile Details", tab: "driver", setTab: toggleTab, data: <div className="row card">
                <div className="row mt-3">
                     <div className='d-flex justify-content-end'>
                                    <button className='btn btn-primary' onClick={()=>salesAgentDetailsFormik.setValues({...driverDetails,gender:{label:capitalizeWords(driverDetails?.gender),value:driverDetails?.gender}})} data-bs-toggle="modal" data-bs-target={`#driverBankModal2`}>Edit</button>
                                        </div>
                    <div className="user-details">
                        <table className="table table-md table-hover card-table">
                            <tbody>
                                {
                                    profileData.map((ele, index) => (
                                        <tr key={index}>
                                            <td>{ele.name}:</td>
                                            <td>{ele.data}</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        },
        { name: "Bank Details", tab: "bankDetails", setTab: toggleTab, data: <div className='p-3 card'><CommonTable headers={bankDetailsHeaderData} data={bankDetailsTableData} /></div> },
        {
            name: "Rate", tab: "rate", setTab: toggleTab, data:
                <div className="card">
                    <div className="card-header d-flex justify-content-end">
                        <h5 className="mb-0"></h5>
                        <button
                            className="btn btn-primary"
                            data-bs-toggle="modal"
                        data-bs-target={`#${driverBankModal2}`}
                        onClick={()=>{
                            salesAgentDetailsFormik.resetForm()
                            setShowTypeField(true)
                        }}
                        >
                            Add
                        </button>
                    </div>
                    <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>s.no</th>
            <th>Type</th>
            <th>Commission</th>
            <th>From</th>
            <th>To</th>
            <th>Reward</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {rateData?.map((row, index) => (
            <tr key={row.id}>
              <td>{index + 1}</td>
              <td>{row.type}</td>
              <td>{row.commission}%</td>
              <td>{row.from}</td>
                  <td>{row.to}</td>
                  <td>
                      <div className="form-check form-switch">
                          <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id={`switch-${row.id}`}
                              checked={row.reward}
                              onChange={(e) => handleRewardToggle(row, e.target.checked)}
                          />
                          {/* <label
                              className="form-check-label"
                              htmlFor={`switch-${row.id}`}
                          >
                              {row.reward ? "Yes" : "No"}
                          </label> */}
                      </div>
                  </td>

                  <td>
                  <div className="dropdown">
                    <button
                      className="border-0 bg-white"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-three-dots-vertical"
                        viewBox="0 0 16 16"
                      >
                        <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                      </svg>
                    </button>
                    <ul className="dropdown-menu" style={{ zIndex: "1000" }}>
                      <li className="dropdown-item">
                        <div
                          style={{ cursor: "pointer" }}
                          onClick={()=>
                          {
                            setShowTypeField(false)
                            salesAgentDetailsFormik.setValues({...row,id:index+1})
                          }
                        } data-bs-toggle="modal" data-bs-target={`#driverBankModal2`}
                        >
                          Edit
                        </div>
                      </li>
                    </ul>
                  </div>
                </td>
            </tr>
          ))}
        </tbody>
      </Table>
     {/* Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedItem ? (
            <div>
              Welcome to Modal 🚀 <br />
              <strong>Type:</strong> {selectedItem.type} <br />
              <strong>Commission:</strong> {selectedItem.commission}% <br />
              <strong>Reward:</strong> {selectedItem.reward}
            </div>
          ) : (
            "No Data"
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
                    {/* <div className="card-header" style={{ backgroundColor: "var(--color-card-bg)" }}>
                        Rate
                    </div>
                    <div className="card-body" >
                        <div className='p-5'>
                            <form onSubmit={rateFormik.handleSubmit}>
                                <div className="form-group row row-cols-4">
                                    <div className='d-flex gap-3'>
                                        <label htmlFor='deliveryFee' className=" col-form-label">Reward Percentage fee</label>
                                        <div className="">
                                            <input type="text" className="form-control" id='rewardPercentage' name='rewardPercentage' placeholder="0" onChange={rateFormik.handleChange} onBlur={rateFormik.handleBlur} value={rateFormik.values.rewardPercentage} />
                                            {rateFormik.touched?.rewardPercentage && rateFormik.errors?.rewardPercentage ? (<div className='req-error'>{rateFormik?.errors?.rewardPercentage}</div>) : null}
                                        </div>
                                    </div>

                                    <div className='d-flex gap-3'>
                                        <label htmlFor='from' className=" col-form-label">From</label>
                                        <div className="">
                                            <DatePicker className='form-control' dateFormat={"dd/MM/yyyy"} placeholderText='dd/MM/yyyy' selected={rateFormik.values?.from ? new Date(rateFormik.values?.from) : null} onChange={(date) => { rateFormik.setFieldValue("from", date) }} />
                                            {rateFormik.touched?.from && rateFormik.errors?.from ? (<div className='req-error'>{rateFormik?.errors?.from}</div>) : null}
                                        </div>
                                    </div>
                                    {console.log(rateFormik?.errors?.from)}
                                    <div className='d-flex gap-3'>
                                        <label htmlFor='deliveryFee' className=" col-form-label">To</label>
                                        <div className="">
                                            <DatePicker className='form-control' name='to' dateFormat={"dd/MM/yyyy"} placeholderText='dd/MM/yyyy' selected={rateFormik.values?.to ? new Date(rateFormik.values?.to) : null} onChange={(date) => { rateFormik.setFieldValue("to", date)}} />
                                            {rateFormik.touched?.rewardPercentage && rateFormik.errors?.rewardPercentage ? (<div className='req-error'>{rateFormik?.errors?.rewardPercentage}</div>) : null}
                                        </div>
                                    </div>

                                    <div className='d-flex align-items-center gap-3'>
                                        <label htmlFor='rewardOnOff' className=" col-form-label">Reward (on/off)</label>
                                        <div className="form-check form-switch">
                                            <input className="form-check-input" type="checkbox" role="switch" checked={rateFormik?.values?.rewardOnOff} id="rewardOnOff" onChange={() => rateFormik?.setFieldValue("rewardOnOff", !Boolean(rateFormik?.values?.rewardOnOff))} />
                                            {rateFormik.touched?.rewardOnOff && rateFormik.errors?.rewardOnOff ? (<div className='req-error'>{rateFormik?.errors?.rewardOnOff}</div>) : null}
                                        </div>
                                    </div>
                                    

                                    <div className="d-flex align-items-end"  >
                                        <button type="submit" className="btn btn-sm btn-primary" disabled={rateLoader}>Submit</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div> */}
                </div>
        },
        {
            name: "Documents", tab: "document", setTab: toggleTab, data: <div className="row card ">
                <div className="mt-3 table-responsive  " style={{ overflowX: "inherit" }}>
                    <table className="table table-md table-hover card-table">
                        <thead>
                            <tr>
                                <th> <span className="list-sort text-muted">Type</span></th>
                                <th className='text-center'> <span className="list-sort text-muted">File</span></th>
                                <th className='text-center'> <span className="list-sort text-muted">Valid Upto</span></th>
                                <th className='text-center'> <span className="list-sort text-muted">Status</span></th>
                                <th className='text-center'> <span className="list-sort text-muted">Action</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* <DocumentDisplay
                                title="Driving Licence"
                                document={salesAgentDetails?.drivingLicence}
                                setSelectedImg={setSelectedImg}
                                status={salesAgentDetails?.drivingLicenceApprovalStatus}
                                keyName={"drivingLicenceApprovalStatus"}
                                validUpto={salesAgentDetails?.drivingLicenceValidUpto}
                            /> */}
                            <DocumentDisplay
                                title="National Id"
                                document={salesAgentDetails?.nationalId}
                                setSelectedImg={setSelectedImg}
                                status={salesAgentDetails?.nationalIdApprovalStatus}
                                keyName={"nationalIdApprovalStatus"}
                                validUpto={salesAgentDetails?.drivingLicenceValidUpto}
                            />
                        </tbody>
                    </table>
                </div>
            </div>
        },

                {
                    name: "Wallet",
                    tab: "wallet",
                    setTab: toggleTab,
                    data: (
                        <div className="row card">
                            <div className="mt-3 table-responsive" style={{ overflowX: "inherit" }}>
                                {walletLoading ? (
                                    <div className="text-center my-4">
                                        <Spinwheel />
                                    </div>
                                ) : (
                                    <table className="table table-md table-hover card-table">
                                        <thead>
                                            <tr>
                                                <th><span className="list-sort text-muted">Amount</span></th>
                                                <th className="text-center"><span className="list-sort text-muted">Status</span></th>
                                                <th className="text-center"><span className="list-sort text-muted">Time</span></th>
                                                <th className="text-center"><span className="list-sort text-muted">Type</span></th>
                                                <th className="text-center"><span className="list-sort text-muted">Remark</span></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {walletHistories.length > 0 ? (
                                                walletHistories.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{item.amount}</td>
                                                        <td className="text-center">
                                                            {item.wallet_status === "credit" ? (
                                                                <span className="badge bg-success">Credit</span>
                                                            ) : (
                                                                <span className="badge bg-danger">Debit</span>
                                                            )}
                                                        </td>
                                                        <td className="text-center">
                                                            {new Date(Number(item.time)).toLocaleString()}
                                                        </td>
                                                        <td className="text-center">{item.type || "-"}</td>
                                                        <td className="text-center">{item.remark || "-"}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="5" className="text-center text-muted">
                                                        No wallet history found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                            {/* ✅ Pagination ko table ke bahar rakha */}
                            <div className="d-flex justify-content-center mt-3 mb-3">
                                <ReactPaginate
                                    nextLabel="Next >"
                                    onPageChange={handlePageClick}
                                    pageRangeDisplayed={3}
                                    marginPagesDisplayed={1}
                                    pageCount={pagination.totalPages || 0}
                                    previousLabel="< Previous"
                                    pageClassName="page-item"
                                    pageLinkClassName="page-link"
                                    previousClassName="page-item"
                                    previousLinkClassName="page-link"
                                    nextClassName="page-item"
                                    nextLinkClassName="page-link"
                                    breakLabel="..."
                                    breakClassName="page-item"
                                    breakLinkClassName="page-link"
                                    containerClassName="pagination"
                                    activeClassName="active"
                                    forcePage={(pagination.currentPage || 1) - 1}
                                />
                            </div>
                        </div>
                    )
                },

                  {
                    name: "Referral",
                    tab: "referral",
                    setTab: toggleTab,
                    data: (
                        <div className="row card">
                            <div className="mt-3 table-responsive" style={{ overflowX: "inherit" }}>
                                {pageLoading ? (
                                    <div className="text-center my-4">
                                        <Spinwheel />
                                    </div>
                                ) : (
                                    <table className="table table-md table-hover card-table">
                                        <thead>
                                            <tr>
                                                <th className=""><span className="list-sort text-muted">Name</span></th>
                                                <th className=""><span className="list-sort text-muted">Email</span></th>
                                                <th className=""><span className="list-sort text-muted">Phone</span></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                                {
                                                    refferals.map((ele, index) => (
                                                        <tr key={index}>
                                                            <td>{ele?.partnerUserDetails[0]?.name}</td>
                                                            <td>{ele?.partnerUserDetails[0]?.email}</td>
                                                            <td>{ele?.phone}</td>
                                                        </tr>
                                                    ))
                                                }
                                        </tbody>
                                    </table>
                                )}
                            </div>
                            <div className="d-flex justify-content-center mt-3 mb-3">
                                <ReactPaginate
                                    nextLabel="Next >"
                                    onPageChange={onPageChangeHandler}
                                    pageRangeDisplayed={3}
                                    marginPagesDisplayed={1}
                                    pageCount={pageInfo.totalPagesCount || 0}
                                    previousLabel="< Previous"
                                    pageClassName="page-item"
                                    pageLinkClassName="page-link"
                                    previousClassName="page-item"
                                    previousLinkClassName="page-link"
                                    nextClassName="page-item"
                                    nextLinkClassName="page-link"
                                    breakLabel="..."
                                    breakClassName="page-item"
                                    breakLinkClassName="page-link"
                                    containerClassName="pagination"
                                    activeClassName="active"
                                    forcePage={(pageInfo.currentPageNumber || 1) - 1}
                                />

                            </div>
                        </div>
                    )
                }

    ]

    return (
        <div className="main-content">
            <div className="container-fluid">

                {loader ? (
                    <div className="text-center">
                        <Spinwheel />
                    </div>
                ) : (
                    <>
                        <div className="row align-items-end">
                            <div className="col-auto">
                                <div className="avatar avatar-xxl header-avatar-top mt-3">
                                    <img src={profileDetails?.profileImage ? `${S3_URL}/${profileDetails?.profileImage}` : "https://img.freepik.com/premium-vector/man-avatar-profile-picture-vector-illustration_268834-538.jpg"} alt="profile" className="avatar-img rounded-circle border border-4 border-body" />
                                </div>
                            </div>
                            <div className="col mb-3 ms-n3 ms-md-n2">
                                <h1 className="header-title">
                                    {capitalizeWords(profileDetails.name)}
                                </h1>
                            </div>
                            <div className="col-12 col-md-auto mt-2 mt-md-0 mb-md-3">
                                {(profileDetails.approvalStatus === "pending") ? <><button type="button" className="btn btn-outline-primary me-2" data-bs-toggle="modal"
                                    data-bs-target={`#confirmationModal`}
                                    onClick={(e) => { setConfirmStatus(prevState => ({ ...prevState, status: "approved", userId: id })) }}>Approve</button>
                                    <button type="button" className="btn btn-outline-secondary" data-bs-toggle="modal"
                                        data-bs-target={`#confirmationModal`}
                                        onClick={(e) => { setConfirmStatus(prevState => ({ ...prevState, status: "rejected", userId: id })) }}>Reject</button></> :
                                    <div className={`badge fs-4  ${profileDetails.approvalStatus === "approved" ? "bg-primary-soft" : "bg-secondary-soft"}`}>{capitalizeWords(profileDetails.approvalStatus)}</div>
                                }
                            </div>
                        </div>

                        <div className='d-flex justify-content-between'>
                            <ul className="nav nav-tabs">
                                {
                                    tabData.map((ele, index) => (
                                        <li className="nav-item">
                                            <button
                                                className={`nav-link ${activeTab === ele.tab ? 'active' : ''}`}
                                                onClick={() => ele.setTab(ele.tab)}
                                            >
                                                {ele.name}
                                            </button>
                                        </li>
                                    ))
                                }
                            </ul>
                            <div>
                            </div>
                        </div>
                        {
                            tabData.map((ele) => (
                                activeTab === ele.tab ? ele.data : null
                            ))
                        }
                    </>
                )}

                <ConfirmationModal
                    handleConfirm={handleChangeStatus}
                    confirmStatus={confirmStatus}
                />
                <ImageViewModal imgUrl={selectedImg} modalId={"imageViewModal"} />
                <button id="confirmationModal2Btn" className='d-none' data-bs-toggle="modal" data-bs-target={`#${confirmationModalId2}`}></button>
                <ConfirmationModal modalId={confirmationModalId2} message={<> Do you want to continue?</>} handleConfirm={() => handleChangeDocumentStatus()} title={"Warning!"} confirmStatus={""} />
                <AddOrUpdateDetails formik={salesAgentDetailsFormik} dataFormat={detailsFields[activeTab]?.format} detailsFor={detailsType?.type} addLoader={detailsType?.loading}  modalId={driverBankModal2}/>
            </div>
        </div>

    );
};

export default SalesAgentDetails;
